/**
 * 数据导出范围
 * @param All 导出全部
 * @param Depart 导出筛选后的数据
 */
enum ExportDataRange{
    /**
     * 导出全部
     */
    All,
    /**
     * 导出筛选后的数据
     */
    Depart
}

export { ExportDataRange }